module.exports = __webpack_public_path__ + "img/whole_foods.1f8c5d87.jpg";